import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PortfolioState {
  private userPortfolioSub$ = new BehaviorSubject<any>({});
  userPortfolio$ = this.userPortfolioSub$.asObservable();

  public get userPortfolioValue() {
    return this.userPortfolioSub$.value;
  }

  public set userPortfolioValue(value) {
    this.userPortfolioSub$.next(value);
  }
  private portfolioContactDetailsSub$ = new BehaviorSubject<Array<any>>([]);

  portfolioContactDetails = this.portfolioContactDetailsSub$.asObservable();

  public get portfolioContactDetailsValue(): Array<any> {
    return this.portfolioContactDetailsSub$.value;
  }

  public set portfolioContactDetailsValue(contactDetails: Array<any>) {
    this.portfolioContactDetailsSub$.next(contactDetails);
  }

  private mlsImageSub$ = new BehaviorSubject<Array<any>>([]);
  mlsImage = this.mlsImageSub$.asObservable();

  public get mlsImageValue(): Array<any> {
    return this.mlsImageSub$.value;
  }

  public set mlsImageValue(mlsImage: Array<any>) {
    this.mlsImageSub$.next(mlsImage);
  }

  private openPortfolioBannerImageSheetSub$ = new BehaviorSubject<boolean>(false);
  openPortfolioBannerImageSheet$ = this.openPortfolioBannerImageSheetSub$.asObservable();
  public get openPortfolioBannerImageSheetValue(): boolean {
    return this.openPortfolioBannerImageSheetSub$.value;
  }
  public set openPortfolioBannerImageSheetValue(status: boolean) {
    this.openPortfolioBannerImageSheetSub$.next(status);
  }

  private portfolioBannerImageSub$ = new BehaviorSubject<any>(null);
  portfolioBannerImage$ = this.portfolioBannerImageSub$.asObservable();

  public get portfolioBannerImageValue() {
    return this.portfolioBannerImageSub$.value;
  }

  public set portfolioBannerImageValue(value) {
    this.portfolioBannerImageSub$.next(value);
  }

  private portfolioProfileImageSub$ = new BehaviorSubject<any>(null);
  portfolioProfileImage$ = this.portfolioProfileImageSub$.asObservable();

  public get portfolioProfileImageValue() {
    return this.portfolioProfileImageSub$.value;
  }

  public set portfolioProfileImageValue(value) {
    this.portfolioProfileImageSub$.next(value);
  }
}
